import { IRootState } from '../../../store'
import { IAuthorizationInformationState } from '../store/authorizationInformation.types'

export const getAuthorizationInformationSelector = (state: IRootState): IAuthorizationInformationState =>
  state.authorizationInformation
